var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-dialog', {
    attrs: {
      "title": " ",
      "visible": _vm.dialogVisible,
      "width": "30%",
      "before-close": _vm.cancel,
      "append-to-body": true
    },
    on: {
      "update:visible": function ($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c('div', {
    staticClass: "left fontSize16"
  }, [_vm._v(_vm._s(_vm.$t('lang.stopLiveConfirm')))]), _c('div', {
    staticClass: "left fontSize14"
  }, [_c('el-checkbox', {
    model: {
      value: _vm.isChecked,
      callback: function ($$v) {
        _vm.isChecked = $$v;
      },
      expression: "isChecked"
    }
  }), _vm._v(_vm._s(_vm.$t('lang.stopLiveCheck')) + " ")], 1), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('lang.cancel')))]), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v(_vm._s(_vm.$t('lang.Ok')))])], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }